<template>
    <div @click="isModalShow = false, closeLanguageSelection()" v-if="isModalShow" class="invisible-div">
        
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isModalShow: false,
            }
        },
        methods: {
            closeLanguageSelection() {
                this.$root.$emit('closeLanguageSelection', false)
            }
        },
        mounted() {
            let _this = this;
            this.$root.$on('popModalShow', function(e){
                _this.isModalShow = e;
            })
        }
    }
</script>

<style lang="less" scoped>
    .invisible-div {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;  
    }
</style>


// WEBPACK FOOTER //
// src/components/PopModal.vue